/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpRespTradeOnApprovalCoachmarkLoader_user$ref = any;
export type PdpRespTradeOnApprovalCoachmarkLoader_user = {
    readonly serviceId: string | null;
    readonly " $refType": PdpRespTradeOnApprovalCoachmarkLoader_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespTradeOnApprovalCoachmarkLoader_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '520265f1673aea4fb5900e1e20a9d5d9';
export default node;
